/**
 * Get the default values for calendar print options. Optionally pass in an existing options object to fill in any missing values
 */
export function calendarPrintOptionDefaults(options = {}) {
    return {
        view: 'month',
        orientation: 'landscape',
        dateRange: { start: '', end: '' },
        trackIds: [],
        athleteId: null,
        includeHubEvents: false,
        deselectedHubEventTypeIds: [],
        fitToPage: false,
        headerText: null,
        headerSize: 'normal',
        showCanceled: false,
        locale: null,
        ...options,
    };
}
//# sourceMappingURL=calendar-print-options.js.map